const rankings = [
  { rank: 1, title: '每日大赛7月总决赛精彩集锦', views: '328.6万', hot: true },
  { rank: 2, title: '每日大赛APP v4.1新功能介绍', views: '256.3万', hot: true },
  { rank: 3, title: '每日大赛最新备用网址汇总帖', views: '198.7万', hot: true },
  { rank: 4, title: '新手必看：每日大赛注册完整教程', views: '175.2万', hot: false },
  { rank: 5, title: '每日大赛iOS安装问题终极解决方案', views: '142.8万', hot: false },
  { rank: 6, title: '每日大赛每日赛程更新时间表', views: '98.4万', hot: false },
  { rank: 7, title: '每日大赛官方网址变更历史记录', views: '76.9万', hot: false },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            每日大赛最受关注的内容与话题排行，实时反映用户关注焦点
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
            {rankings.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 px-5 py-4 ${
                  idx < rankings.length - 1 ? 'border-b border-background-200/50' : ''
                } hover:bg-background-200/50 transition-colors`}
              >
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                    item.rank === 1
                      ? 'bg-primary-500 text-background-50'
                      : item.rank === 2
                      ? 'bg-primary-400 text-background-50'
                      : item.rank === 3
                      ? 'bg-accent-400 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-800 truncate">
                    {item.title}
                  </p>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  {item.hot && (
                    <span className="hidden sm:inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                      <i className="ri-fire-fill text-[10px]"></i>
                      热门
                    </span>
                  )}
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.views}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}